import {BadRequestException, BadRequestMessageStatusTypes} from "./badRequestException.ts";
import {UnauthorizedException, UnauthorizedMessageStatusTypes} from "./unauthorizedException.ts";
import {ForbiddenException, ForbiddenMessageStatusTypes} from "./forbiddenException.ts";
import {NotFoundException, NotFoundMessageStatusTypes} from "./notFoundException.ts";
import {InternalServerErrorException} from "./internalServerErrorException.ts";

export class AxiosException {
    constructor(code: number, msgCode: BadRequestMessageStatusTypes | UnauthorizedMessageStatusTypes | ForbiddenMessageStatusTypes | NotFoundMessageStatusTypes | string, message: string) {
        if(code === 400)
            throw BadRequestException(msgCode, message);
        else if(code === 401)
            throw UnauthorizedException(msgCode, message);
        else if(code === 403)
            throw ForbiddenException(msgCode, message);
        else if(code === 404)
            throw NotFoundException(msgCode, message);
        else
            throw InternalServerErrorException("Something went wrong...");
    }
}